import { Portal, Box } from '@mui/material';

import { DrawerTypes } from '../common/context/IMCContext.interface';

import MessageCenterDrawer from './components/MessageCenterDrawer';
import UnreadNotification from './components/MessageCenterContent/MessageList/MessageItem/UnreadNotification';

import { useIMCContext } from 'modules/IMC/common/context';
import useMessageCenterCopy from 'modules/IMC/common/hooks/useMessageCenterCopy';
import { MessageCenterContextProvider } from 'modules/IMC/MessageCenter/context';
import ChipButton from 'modules/common/components/Layout/Header/ChipButton';
import MessageCenterIcon from 'modules/common/components/Icons/MessageCenterIcon';

export default function MessageCenter({
    includePortal = true,
    hasPaymentIssue = false,
}: {
    includePortal?: boolean;
    hasPaymentIssue?: boolean;
}) {
    const { openDrawer, hasUnreadMessages } = useIMCContext();
    const { messagesButtonLabel } = useMessageCenterCopy();

    return (
        <>
            <ChipButton
                onClick={() => openDrawer(DrawerTypes.MESSAGE_CENTER)}
                icon={
                    <Box sx={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
                        <MessageCenterIcon sx={{ fontSize: '1em', marginRight: hasUnreadMessages ? 1 : 0 }} />
                        <UnreadNotification
                            show={hasUnreadMessages}
                            sx={{ position: 'absolute', left: -2, top: -12 }}
                        />
                    </Box>
                }
                sx={{
                    display: { xs: 'none', lg: 'inline-flex' },
                    ...(hasPaymentIssue && {
                        backgroundColor: 'secondary.lightHover',
                    }),
                }}
                variant="outlined"
                label={messagesButtonLabel}
            />
            <ChipButton
                onClick={() => openDrawer(DrawerTypes.MESSAGE_CENTER)}
                icon={
                    <Box sx={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
                        <MessageCenterIcon sx={{ fontSize: '1em' }} />
                        <UnreadNotification
                            show={hasUnreadMessages}
                            sx={{ position: 'absolute', left: -2, top: -12 }}
                        />
                    </Box>
                }
                sx={{
                    display: { xs: 'inline-flex', lg: 'none' },
                    '& .MuiChip-label': { display: 'none' },
                    '& .MuiChip-icon': { margin: 0 },
                    minWidth: 'auto',
                    padding: '8px 16px',
                    ...(hasPaymentIssue && {
                        backgroundColor: 'secondary.lightHover',
                    }),
                }}
                variant="outlined"
                label=""
            />
            {includePortal && (
                <Portal>
                    <MessageCenterContextProvider>
                        <MessageCenterDrawer drawerProps={{ variant: 'temporary' }} />
                    </MessageCenterContextProvider>
                </Portal>
            )}
        </>
    );
}
